"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Profile = function Profile(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.155 9.552a3.684 3.684 0 001.417-2.9 3.703 3.703 0 00-3.697-3.696A3.7 3.7 0 006.18 6.652c0 1.176.556 2.224 1.412 2.9-2.752.948-4.736 3.56-4.736 6.628a.652.652 0 001.304 0 5.718 5.718 0 015.712-5.712 5.718 5.718 0 015.713 5.712.652.652 0 001.303 0c.005-3.068-1.98-5.676-4.732-6.628zm-2.28-5.288a2.392 2.392 0 012.389 2.388A2.392 2.392 0 019.875 9.04a2.392 2.392 0 01-2.388-2.388 2.392 2.392 0 012.388-2.388z",
    fill: color
  }));
};
var _default = exports["default"] = Profile;